import Lottie from 'react-lottie-player';
import lottieJson from './lottie/Gift-1711676777432.json';
import styles from "./css/dark-theme.module.css";
import React, {Component} from "react";
import axios from "axios";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import loadingLottieJson from "./lottie/animation_lkfxk9f1";

const authKey = process.env.REACT_APP_AUTH_KEY;
const prodServerUrl = process.env.REACT_APP_PROD_SERVER;
const localServerUrl = process.env.REACT_APP_LOCAL_SERVER;
const nodeEnv = process.env.REACT_APP_NODE_ENV;
let serverUrl = 'Check env';
if (nodeEnv === 'dev') {
    serverUrl = localServerUrl;
}
if (nodeEnv === 'prod') {
    serverUrl = prodServerUrl;
}

class Airdrops extends Component {

    state = {
        isLoaded: false,
        apiData: [],
    };
    async componentDidMount() {
        const packets = {
            authToken: authKey,
        };
        try {
            await axios.post(serverUrl + '/apiv2/g/airdrops', packets, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                this.setState({ apiData: response.data.data, isLoaded: true,});
            });
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        const lottieWidth = window.innerWidth * 30 / 100;

        if (!this.state.isLoaded) {
            return (
                <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center" p={5}>
                    <Grid item xs={12} lg={4}> </Grid>
                    <Grid item xs={12} lg={4}>
                        <Lottie
                            loop
                            animationData={loadingLottieJson}
                            play
                            style={{width: lottieWidth, align:"center", }}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4}> </Grid>
                </Grid>
            );
        }
    return (
        <Box sx={{flexGrow: 1}} p={1}>
            <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center" p={5}>
                <Grid item xs={12} lg={4} className={styles.homepageSecondBlock} ml={2}>
                    <h2>All token/coin drops from projects on one page.</h2>
                    <small>
                        - Airdrops on Testnet
                        <br></br>
                        - Airdrops on Mainnet
                        <br></br>
                        - Retrodrops
                    </small>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Lottie
                        loop
                        animationData={lottieJson}
                        play
                        style={{width: lottieWidth, align:"center", margin:"0 0 0 100px" }}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center" p={5}>
                <Grid item xs={12} lg={12}>
                    <Stack
                        spacing={{ xs: 1, sm: 2, md: 2 }}
                        direction="row" useFlexGap flexWrap="wrap"
                        justifyContent="center"
                        alignItems="center"
                    >
                {this.state.apiData['airdrops'].data.map((item) => {
                    let deadline = '';
                    if (item.finished_at == null) {
                        deadline = 'No deadline yet';
                    } else {
                        deadline = 'Deadline: '+item.finished_at;
                    }
                    return (
                        <Button variant="outlined" className={styles.buttonLastAirdrops}>
                            <a href={'airdrops/' + item.link}>
                                <img src={item.image} height={100} width={100}
                                         alt={item.coin_symbol}/>
                                         <p> {item.title} || {item.airdrop_type} || {deadline}</p>
                            </a>
                        </Button>
                    );
                })}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
    }
}
export default Airdrops;